import { CommunicationMethod } from '../global/CommunicationMethod';
import { Lookup } from '../lookups/Lookup';
import { EntityEnumSLA } from '../sla/enums/EntityEnumSLA';
import { LabType } from './enums/LabType';

export class LabDetails {
  id?: number;
  labType!: LabType;
  mainLab!: Lookup;
  labName!: string;
  logo!: string;
  plagiarismThreshold!: string;
  basicInfo!: {
    address: string;
    contactNumberFlag: string;
    contactNumberExtension: string;
    contactNumber: string;
    email: string;
    managerName: string;
    managerFirstName: string;
    managerLastName: string;
    isEmailVerified: boolean;
    isMobileVerified: boolean;
  };
  country!: Lookup;
  region!: Lookup;
  city!: Lookup;
  managerName!: string;
  communicationMethod!: CommunicationMethod[];
  // canSendToSC: boolean;
  // canSendToVL: boolean;
  // scanningCenters: Lookup[];
  casesCount!: number;
  labUserDetails!: Lookup[];
  branches!: Lookup[];
  canDeleteLab!: boolean;
  createdOn!: string;
  entity!: {
    entityId: number;
    entityType: EntityEnumSLA,
    entityName: string;
    logoUrl: string;
  };
  closedCasesCount!: number;
  openCasesCount!: number;
  subscribePlan!: subscribePlan
  isPathology!: boolean
}

export class subscribePlan {
  id!: number;
  title!: string;
  amount!: number;
  subscribedOn!: string;
  nextPayment!: string;
}
